import type { FC } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useAppStore } from '../../../../store/app/appStore';
import type { ISettings } from 'types/models/ISettings';
import { asset } from '../../../../shared/utils/helpers';

import styles from './HelpTab.module.css';

const getHelpUrl = (settings: ISettings) => {
  let htmlFolderPath: string = '';
  const lang = settings.languageCode.toLowerCase();

  if (settings.restrictions.indexOf('noJackpot') !== -1) htmlFolderPath = 'noJackpot/';
  
  return `/assets/portal/help/${htmlFolderPath}${lang}.html`;
};

const HelpTab: FC = () => {
  const { settings } = useAppStore.getState();

  const {
    data: helpContent,
    error,
  } = useQuery({
    queryFn: () => fetchHelpContent(settings),
    queryKey: ['helpContent', settings.languageCode, settings.host],
  });

  const fetchHelpContent = async (settings: ISettings): Promise<string> => {
    const version: string = process.env['VERSION'] ? `${process.env['VERSION']}` : '';
    const helpUrl = asset(settings, getHelpUrl(settings));
    
    const response = await fetch(helpUrl);
    const text = await response.text();

    const updatedHtml = text
      .split('src="')
      .map((t, idx) => {
        const s = t.split('"');
        if (idx > 0) {
          s[0] = asset(settings, s[0]);
        }
        return s.join('"');
      })
      .join('src="')
      .replace(/##VERSION##/g, version);

    return updatedHtml;
  };

  if (error || !helpContent) return <div>Error loading help content</div>;

  return (
    <div className={styles.container}>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: helpContent }} />
    </div>
  );
};

export default HelpTab;
